import { useEffect } from 'react';

// Module-level ref count so multiple overlays across multiple tabs cooperate
// instead of fighting over `document.body.style.overflow`. Lock when count > 0,
// restore the original value when it returns to 0.
let lockCount = 0;
let originalOverflow = '';

export function useBodyScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return undefined;

    if (lockCount === 0) {
      originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    lockCount++;

    return () => {
      lockCount--;
      if (lockCount === 0) {
        document.body.style.overflow = originalOverflow;
      }
    };
  }, [active]);
}
